import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateTimePickerComponent } from './component/dateTime-picker.component';
import { DpDatePickerModule } from 'ng2-date-picker';
import { FormsModule } from '@angular/forms';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';

@NgModule({
  declarations: [DateTimePickerComponent],
  imports: [
    CommonModule,
    DpDatePickerModule,
    FormsModule,
    TranslatePipe, TranslateDirective
  ],
  exports: [DateTimePickerComponent]
})
export class DateTimePickerStaticModule { }
